import e from "@dialpad/dialtone-tokens/layered/themes/tokens-tropical-night-colors.css?inline";
//#region themes/tropical-night.js
var t = {
	brand: {
		css: e,
		name: "tropical-night"
	},
	material: { name: "jade" }
};
//#endregion
export { t as default };
